
import React, { useEffect, useRef, useState } from 'react';

import './ButtonOptionDropdown.scss';

interface DropdownOption {
    label: string;
    onClick: () => void;
}

interface ButtonOptionDropdownProps {
    primary?: boolean;
    secondary?: boolean;
    tertiary?: boolean;
    size?: 'standard' | 'small';
    disabled?: boolean;
    onClickMain: () => void;
    children: JSX.Element;
    options: DropdownOption[];
}

function ButtonOptionDropdown({ primary, secondary, tertiary, size = 'standard', disabled, onClickMain, children, options }: ButtonOptionDropdownProps) {
    const [isOpen, setIsOpen] = useState(false);
    const wrapperRef = useRef<HTMLDivElement>(null);

    const themeClass = `${primary ? 'primary' : ''} ${secondary ? 'secondary' : ''} ${tertiary ? 'tertiary' : ''}`.trim();
    const sizeClass = size === 'small' ? 'size_small' : 'size_standard';
    const openClass = isOpen ? 'open' : '';

    useEffect(() => {
        if (!isOpen) return;
        const handleOutsideClick = (e: MouseEvent) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleOutsideClick);
        return () => document.removeEventListener('mousedown', handleOutsideClick);
    }, [isOpen]);

    const handleMainClick = () => {
        if (isOpen) {
            setIsOpen(false);
            return;
        }
        onClickMain();
    };

    const handleChevronClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        setIsOpen(prev => !prev);
    };

    const handleOptionClick = (optionOnClick: () => void) => {
        setIsOpen(false);
        optionOnClick();
    };

    return (
        <div ref={wrapperRef} className={`__ButtonOptionDropdown ${themeClass} ${sizeClass} ${openClass}`}>
            <button
                className="__mainAction"
                onClick={handleMainClick}
                disabled={disabled}
                type="button"
            >
                {children}
            </button>
            <button
                className="__chevronTrigger"
                onClick={handleChevronClick}
                disabled={disabled}
                type="button"
            >
                <span className="material-icons">expand_more</span>
            </button>
            {isOpen && (
                <div className="__dropdownOverlay">
                    {options.map((opt, i) => (
                        <button
                            key={i}
                            className="__option"
                            type="button"
                            onClick={() => handleOptionClick(opt.onClick)}
                        >
                            {opt.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}

export default ButtonOptionDropdown;
